import http from "@/utils/request";

const customerApi = {
  pageQuery: data =>
    http.sendRequest({
      METHOD_NAME: "customer.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  create: data =>
    http.sendRequest({
      METHOD_NAME: "customer.create",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  update: data =>
    http.sendRequest({
      METHOD_NAME: "customer.update",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  load: data =>
    http.sendRequest({
      METHOD_NAME: "customer.load",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    })
};

export default customerApi;
